<template>
  <section class="mainChain">
    <div class="mainChain-title">
      <!-- 链名称 -->
      {{ $t("assets.branchName") }}
      <div class="mainChain-page-icon">
        <a-tooltip
          v-if="branchTip"
          placement="bottom"
          :arrowPointAtCenter="true">
          <svg-icon class="icon icon-12" icon-class="rechargeTips"></svg-icon>
          <template slot="title">
            <div class="mainChain-page-market">
              {{ branchTip }}
            </div>
          </template>
        </a-tooltip>
        <!-- <svg-icon class="icon icon-12" icon-class="rechargeTips"></svg-icon>
        <ul class="mainChain-page-market a-4-bg"> -->
          <!-- <li>{{ branchTip }}</li> -->
          <!-- <li class="warn b-7-cl">
            充提时请务必核对USDT的主链类型
          </li> -->
        <!-- </ul> -->
      </div>
    </div>
    <ul class="branchList main-cl">
      <li
        v-for="(item, index) in branchArr"
        :key="index"
        :class="item.code === activeBranch ? 'blue-bg white-cl' : 'gray-30-bg'"
        @click="setActiveBranch(item.code)"
      >
        {{ item.value }}
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'mainChain',
  props: {
    branchArr: {
      type: Array,
      default: () => [],
    },
    activeBranch: {
      type: String,
      default: '',
    },
    branchTip: {
      type: String,
      default: '',
    },
  },
  methods: {
    setActiveBranch(v) {
      if (v === this.activeBranch) return;
      this.$emit('setActiveBranch', v);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/common.scss';

.mainChain {
  font-family: 'Medium';

  .mainChain-page-icon {
    // line-height: 28px;
    cursor: pointer;
    display: inline-block;
    position: relative;

    &:hover {
      .mainChain-page-market {
        display: block;
        li {
          word-break: break-all;
          font-size: 12px;
          line-height: 16px;
          margin-bottom: 4px;
        }
        .warn {
          margin-top: 10px;
        }
      }
    }

    .mainChain-page-market {
      word-break: break-all;
      box-shadow: 0 3px 4px 1px rgba(0, 0, 0, 0.28);
      display: none;
      position: absolute;
      top: 14px;
      width: 320px;
      padding: 20px;
      left: 0;
      box-sizing: border-box;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 20px;
      z-index: 4;
    }
  }
  .mainChain-title {
    font-size: 12px;
    margin-bottom: 8px;

    span {
      margin-right: 7px;
    }
  }

  .branchList {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;

    li {
      width: 138px;
      text-align: center;
      box-sizing: border-box;
      padding: 14px 0;
      font-size: 14px;
      height: 40px;
      cursor: pointer;
      border-radius: 4px;
    }
  }
}
.mainChain-page-market {
  width: 340px;
  padding: 20px;
  box-sizing: border-box;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 20px;
}
</style>
